import React from 'react';
import moment from 'moment';
import numeral from 'numeral';
import { apiGet, apiPost } from '../../../../services/apiClient';
import { getRoles } from '../../../../services/userRights';
import ConfirmModal from '../../../../modals/confirmModal.jsx';
import InformationModal from '../../../../modals/infoModal.jsx';
import FillRecipientCompanyModal from '../../../../modals/fillRecipientCompanyModal.jsx';
import CheckBoxInput from '../../../../controls/checkBoxInput.jsx';
import DateTimeInput from '../../../../controls/dateTimeInput.jsx';
import { isUndefined } from 'util';
import './costCalcTab.css';

export default class CostCalcTab extends React.Component {
    constructor(args) {
        super(args);

        this.state = {
            busyCount: 0
        };

		this.confirmModal = null;
		this.infoModal = null;
		this.fillRecipientModal = null;
    }

    updateBusyCount(inc) {
        this.setState((prevState, props) => {
            prevState.busyCount = prevState.busyCount + inc;
            return prevState;
        });
    }

	initParcelData(parcel) {
		parcel.carrierPublicOfferUrl = null;
		parcel.carrierCostRequests = [];
		parcel.allStatusNotifications = false;
        return parcel;
    }

	reloadReferences() {
        return this.handleRequestsChange(this.props.parcel.carrierCostRequests);
    }

	convertToResultEntry(entry) {
		return {
			carrierId: entry.carrierId,
			carrierServiceCode: entry.carrierServiceCode,
			carrierServiceName: entry.carrierServiceName,
			cost: entry.cost,
			rawCost: entry.rawCost,
			tariffRate: entry.tariffRate,
			departureDate: entry.departureDate,
			minDeliveryTime: entry.minDeliveryTime,
			maxDeliveryTime: entry.maxDeliveryTime,
			deliveryTimeComment: entry.deliveryTimeComment,
			status: entry.status,
			statusComment: entry.statusComment,
			isSelected: entry.isSelected,
			claimId: entry.claimId,
			version: entry.version,
			tariff: entry.tariff
		};
	}

    fillModel(parcel) {
		if (this.props.parcel.carrierCostRequests) {
			parcel.carrierCostRequests = this.props.parcel.carrierCostRequests.map((entry, ind, arr) => this.convertToResultEntry(entry));
		}
		parcel.allStatusNotifications = this.props.parcel.allStatusNotifications;
        return parcel;
    }

    hasFormErrors(errors) {
        return !isUndefined(errors) && errors.selection;
    }

	compareRequestResults(r1, r2) {
		var r1Cost = r1.cost ? numeral(r1.cost).value() : null;
		var r1Error = r1.status === 'Error';

		var r2Cost = r2.cost ? numeral(r2.cost).value() : null;
		var r2Error = r2.status === 'Error';

		if (r1Error && !r2Error) {
			return 1;
		} else if (!r1Error && r2Error) {
			return -1;
		} else if (r1Cost !== null && r2Cost !== null) {
			if (r1Cost === r2Cost) {
				return 0;
			} else if (r1Cost < r2Cost) {
				return -1;
			} else {
				return 1;
			}
		} else if (r1Cost === null && r2Cost === null) {
			if (r1.name === r2.name) {
				return 0;
			} else if (r1.name < r2.name) {
				return -1;
			} else {
				return 1;
			}
		} else if (r2Cost === null) {
			return -1;
		} else {
			return 1;
		}
	}

	handleRequestsChange(costRequests) {		
		if (costRequests) {
			costRequests.sort(this.compareRequestResults);
		}
        return this.props.onFieldChange([
            {
                name: "carrierCostRequests",
                value: costRequests
			}
        ]);
    }

	clearCarrier() {
		this.props.onFieldChange([
            {
                name: "carrierId",
                value: null
            }
        ]);
		if (this.props.onFieldEdited) {
			this.props.onFieldEdited("carrierId", null);
		}
	}

    validateForm(fieldName) {
		var result = null;

		if (isUndefined(fieldName)) {
			if (!this.props.parcel.carrierCostRequests || this.props.parcel.carrierCostRequests.length === 0) {
				result = result ? result : {};
				result.selection = "Необходимо запросить актуальную стоимость";
			} else {
				var hasSelection = false;
				this.props.parcel.carrierCostRequests.forEach((entry, ind, arr) => {
					if (entry.isSelected) {
						hasSelection = true;
					}
				});
				if (!hasSelection) {
					result = result ? result : {};
					result.selection = "Необходимо выбрать один из вариантов доставки";
				}
			}

            if (this.props.parcel.isDeliveryTimeSpecified && !this.props.parcel.deliveryTime) {
                result = result ? result : {};
                result.deliveryTime = "Желаемая дата и время доставки является обязательным полем, если доставка к определенному времени запрошена";
            }

			if (this.props.parcel.deliveryTime && moment(this.props.parcel.deliveryTime).isBefore('1900-01-01')) {
                result = result ? result : {};
                result.deliveryTime = "Желаемая дата и время доставки имеет некорректное значение";
			} else if (this.props.parcel.departureDate 
						&& this.props.parcel.deliveryTime 
						&& moment(this.props.parcel.departureDate) > moment(this.props.parcel.deliveryTime)) {
                result = result ? result : {};
                result.deliveryTime = "Желаемая дата и время доставки не может быть раньше Даты отправки груза";
            }
		}

        return result;
    }

    addPending(carrier) {
        let newEntry = {
            carrierId: carrier.id,
            carrierName: carrier.name,
            carrierPublicOfferUrl: carrier.publicOfferUrl,
            status: 'Sent',
            isSelected: false
        };
		let newEntries = this.props.parcel.carrierCostRequests;
		newEntries.push(newEntry);
		this.handleRequestsChange(newEntries);
        return newEntry;
    }

    addSkipped(carrier) {
        let newEntry = {
            carrierId: carrier.id,
            carrierName: carrier.name,
            carrierPublicOfferUrl: carrier.publicOfferUrl,
			isDeliveryTimeSpecified: false,
			deliveryTime: '',
			minDeliveryTime: null,
			maxDeliveryTime: null,
            status: 'Skip',
            isSelected: false
        };
		let newEntries = this.props.parcel.carrierCostRequests;
		newEntries.push(newEntry);
		this.handleRequestsChange(newEntries);
        return newEntry;
    }

    saveResults(carrierId, newEntries) {
        newEntries.forEach((entry, ind, arr) => {
			entry.isDeliveryTimeSpecified = false;
			entry.deliveryTime = entry.maxDeliveryTime;
        });
        let newStateEntries = [];
        let isFirstEntry = true;
		let isUpdated = false;
        this.props.parcel.carrierCostRequests.forEach((oldEntry, ind, arr) => {
            if (oldEntry.carrierId === carrierId) {
                if (isFirstEntry) {
                    newStateEntries = newStateEntries.concat(newEntries);
                    isFirstEntry = false;
					isUpdated = true;
                }
            } else {
                newStateEntries.push(oldEntry);
            }
        });
		if (!isUpdated) {
            newStateEntries = newStateEntries.concat(newEntries);
		}
		this.handleRequestsChange(newStateEntries);
    }

    markAsFailed(entry, errorMessage) {
		var newEntry = null;
		let newEntries = this.props.parcel.carrierCostRequests;
        newEntries.forEach((stateEntry, ind, arr) => {
            if (stateEntry === entry) {
                stateEntry.status = 'Error';
                stateEntry.statusComment = errorMessage;
				newEntry = stateEntry;
            }
        });
		this.handleRequestsChange(newEntries);
    }

	getCostCalcRequest() {
        let parcelData = null;
		if (this.props.isNew) {
			parcelData = this.props.getParcelModel();
		} else {
			parcelData = this.props.parcel;
		}
        var costRequest = {
            companyId: parcelData.companyId,
			subCompanyId: parcelData.subCompanyId,
			departureDate: parcelData.departureDate,
			declaredCargoValue: parcelData.declaredCargoValue,
            parcelType: parcelData.parcelType,
            volume: parcelData.volume,
			weight: parcelData.weight,			
            packagesCount: parcelData.packagesCount,
            shipmentAddressId: parcelData.shipmentAddressId,
            shipmentAddress: parcelData.shipmentAddress,
            deliveryAddressId: parcelData.deliveryAddressId,
            deliveryAddress: parcelData.deliveryAddress,
			isReturnRequested: parcelData.isReturnRequested,
			isLoadingRequested: parcelData.isLoadingRequested,
			isPackagingRequested: parcelData.isPackagingRequested,
			isValueDeclared: parcelData.isValueDeclared,
			senderContactInfo: parcelData.senderContactInfo,
            recipientContactInfo: parcelData.recipientContactInfo,
            deliveryTypeCode: parcelData.deliveryTypeCode
		};		
		if (parcelData.length !== null) {
			costRequest.length = parcelData.length;
		}
		if (parcelData.height !== null) {
			costRequest.height = parcelData.height;
		}
		if (parcelData.width !== null) {
			costRequest.width = parcelData.width;
		}
		if (!this.props.isNew) {
			costRequest.parcelId = this.props.parcel.id;
		}
        return costRequest;
    }

	initNewList() {
		this.clearCarrier();
		if (this.props.isNew) {
			return Promise.resolve();
		} else {
			return apiPost('parcels/cost/' + this.props.parcel.id + '/initNewList')
					.then(response => {
						response.costs.forEach((entry, ind, arr) => {
							this.saveResults(entry.carrierId, [entry]);
						});
					});
		}
	}

    sendRequests() {
        var costRequest = this.getCostCalcRequest();
        this.props.clearErrors();
		this.handleRequestsChange([])
			.then(() => {
				this.initNewList()
					.then(() => {
                        apiGet('parcels/cost/carriers/' + this.props.parcel.companyId)
							.then(response => {

								if (response.entries) {
									response.entries.forEach((entry, ind, arr) => {
										if (entry.hasIntegration) {
											let requestEntry = this.addPending(entry);
											apiPost('parcels/cost/calc/' + entry.id, costRequest)
												.then(response => {
													if (response.isComplete) {
														this.saveResults(entry.id, response.costs);
														$('[data-toggle="popover"]').popover();
													}	
												})
												.catch(err => {
													let errorMessage = err.messages ? err.messages.request : null;
													this.markAsFailed(requestEntry, errorMessage);
												});
										} else if (this.props.isNew) {
											this.addSkipped(entry);
										}
									});
								}
							});
					});
			});
    }

    updateRequests() {
        this.props.parcel.carrierCostRequests.forEach((entry, ind, arr) => {
            if (entry.status === 'Sent' && entry.requestId) {
                apiPost('parcels/cost/calc/refresh', { requestId: entry.requestId })
                    .then(response => {
                        if (response.isComplete) {
                            this.saveResults(entry.carrierId, response.costs);
                        }
                    })
                    .catch(err => {
						let errorMessage = err.messages ? err.messages.request : null;
                        this.markAsFailed(entry, errorMessage);
                    });
            }
        });
    }

	selectCostEntry(entry, confirmed) {
		if (entry.isRecipientCompanyRequired
			&& (!this.props.parcel.recipientCompanyName || this.props.parcel.recipientCompanyName.length == 0
				|| !this.props.parcel.recipientInn || this.props.parcel.recipientInn.length == 0)) {
			this.fillRecipientModal.open(this.props.parcel.recipientInn, this.props.parcel.recipientCompanyName)
				.then(data => {
					this.props.onFieldChange([
						{
							name: "recipientInn",
							value: data.recipientInn
						},
						{
							name: "recipientCompanyName",
							value: data.recipientCompanyName
						}
					])
					.then(() => this.selectCostEntry(entry));
				});
			return;
		}

		if (entry.tariff && entry.tariff.needConfirmation && !confirmed) {
			this.confirmModal.open("Выбор транспортной компании", entry.tariff.confirmationMessage, "Да", "Нет")
				.then(() => this.selectCostEntry(entry, true));
			return;
        }

		if (this.props.isNew) {
			this.props.clearErrors();
			let newEntries = this.props.parcel.carrierCostRequests;
			newEntries.forEach((stateEntry, ind, arr) => {
				if (stateEntry === entry) {
					stateEntry.isSelected = true;
				}
			});
			let fieldUpdates = [
				{
					name: 'carrierId',
					value: entry.carrierId
				},
				{
					name: 'isDeliveryTimeSpecified',
					value: entry.isDeliveryTimeSpecified
				},
				{
					name: 'deliveryTime',
					value: entry.isDeliveryTimeSpecified ? entry.deliveryTime : ''
				},
				{
					name: "carrierCostRequests",
					value: newEntries
				},
				{
					name: "carrierPublicOfferUrl",
					value: entry.carrierPublicOfferUrl
				}
			];
			if (entry.status === 'Skip') {
				fieldUpdates.push({
					name: 'deliveryCost',
					value: ''
				});
			} else {
				fieldUpdates.push({
					name: 'carrierServiceCode',
					value: entry.carrierServiceCode
				});
				fieldUpdates.push({
					name: 'carrierServiceName',
					value: entry.carrierServiceName
				});
				fieldUpdates.push({
					name: 'deliveryCost',
					value: entry.cost
				});
				fieldUpdates.push({
					name: 'rawDeliveryCost',
					value: entry.rawCost
				});
				fieldUpdates.push({
                    name: 'tariffRate',
                    value: entry.tariffRate
				});
				fieldUpdates.push({
					name: 'claimId',
					value: entry.claimId
				});
				fieldUpdates.push({
					name: 'version',
					value: entry.version
				});
			}
			this.props.onFieldChange(fieldUpdates);
		} else {
			let data = {
				parcelId: this.props.parcel.id,
				entryId: entry.id,
				isDeliveryTimeSpecified: entry.isDeliveryTimeSpecified,
				deliveryTime: entry.isDeliveryTimeSpecified ? entry.deliveryTime : '',
				recipientInn: this.props.parcel.recipientInn,
				recipientCompanyName: this.props.parcel.recipientCompanyName,
			};
			apiPost('parcels/cost/select', data)
				.then(() => {
					this.props.reload();
				});
		}
    }

    renderSelectButton(entry, disabled, hasSelection) {
        if ((entry.status === 'Skip' || entry.status === 'Complete') && !hasSelection) {
            return (
                <button className="btn btn-flat btn-default btn-sm pull-right"
                    onClick={() => this.selectCostEntry(entry)}
                    disabled={disabled}
                >
                    Выбрать
                </button>
            );
        } else {
            return null;
        }
    }

    renderEntryStatus(entryStatus, statusComment) {
        if (entryStatus === 'Sent') {
            return <span className="badge bg-yellow" title={statusComment}>Заявка отправлена</span>;
        } else if (entryStatus === 'Error') {
            return <span className="badge bg-red" title={statusComment}>Ошибка</span>;
        } else if (entryStatus === 'Complete') {
            return <span className="badge bg-green" title={statusComment}>Заявка обработана</span>;
        } else if (entryStatus === 'Skip') {
            return <span className="badge bg-blue" title={statusComment}>Без интеграции</span>;
        } else {
            return null;
        }
    }

	onEntryDeliveryTimeChanged(entry, isRequired, value) {
		let validationError = null;
		if (isRequired) {
			if (!value) {
				validationError = 'Необходимо указать предпочтительную дату и время доставки';
			} else if (moment(value) < moment(this.props.parcel.departureDate)) {
				validationError = 'Дата доставки не может быть раньше даты отгрузки';
			}
		}
		let newEntries = this.props.parcel.carrierCostRequests;
		newEntries.forEach((stateEntry, ind, arr) => {
			if (stateEntry.carrierId === entry.carrierId && stateEntry.carrierServiceCode === entry.carrierServiceCode) {
				stateEntry.isDeliveryTimeSpecified = isRequired;
				stateEntry.deliveryTime = value;
				stateEntry.deliveryTimeError = validationError;
			}
		});
		this.handleRequestsChange(newEntries);
	}

	renderIsDeliveryTimeSpecifiedControl(entry, disabled, hasSelection) {
		if ((entry.status === 'Skip' || entry.status === 'Complete') && !hasSelection) {
            return (
                <CheckBoxInput className="delivery-time-checkbox"
					checked={entry.isDeliveryTimeSpecified}
                    onChange={value => this.onEntryDeliveryTimeChanged(entry, value, entry.deliveryTime)}
                    disabled={disabled}
                />
            );
		} else {
			return null;
		}
	}

	renderDeliveryTimeControl(entry, disabled, hasSelection) {
        if ((entry.status === 'Skip' || entry.status === 'Complete') && entry.isDeliveryTimeSpecified && !hasSelection) {
            return (
                <DateTimeInput className="delivery-time-date"
                    enableTime={true}
                    openDirection="down"
                    onChange={value => this.onEntryDeliveryTimeChanged(entry, entry.isDeliveryTimeSpecified, value)}
                    value={entry.deliveryTime}
                    title={entry.deliveryTimeError}
                    disabled={disabled}
                />
            );
        } else if (entry.isSelected && entry.isDeliveryTimeSpecified) {
            let deliveryDate = moment(entry.deliveryTime).format("DD.MM.YYYY HH:mm");
            return <span>{deliveryDate}</span>;
		} else {
			return null;
		}
	}

	renderErrorsList() {
		if (this.props.parcel.carrierCostRequests) {
			let entries = this.props.parcel.carrierCostRequests.map((entry, ind, arr) => {
				
				if(entry.status !== "Error")
					return;

				let rowClass = entry.isSelected ? 'bg-green disabled' : '';
				let key = 'error' + ind;
				return (
					<tr key={key} className={rowClass}>
						<td>
							{entry.carrierName}
						</td>
						<td>
							{entry.statusComment}
						</td>
					</tr>
				);
			});

			if(entries.length === 0)
				return;

			return  <div className="box-body table-responsive">
						<table className="table table-bordered table-hover static-grid">
							<thead>
								<tr>
									<th>Транспортная компания</th>
									<th>Ошибка</th>
								</tr>
							</thead>
							<tbody>
								{entries}
							</tbody>
						</table>
					</div>
		} else {
			return null;
		}
	}

    renderEntries(disabled) {
		if (this.props.parcel.carrierCostRequests) {
			var hasSelection = false;
			this.props.parcel.carrierCostRequests.forEach((entry, ind, arr) => {
				if (entry.isSelected) {
					hasSelection = true;
				}
			});
			let entries = this.props.parcel.carrierCostRequests.map((entry, ind, arr) => {
				let key = 'cost-car-' + entry.carrierId + '-urg-' + (entry.carrierServiceCode ? entry.carrierServiceCode : 'none');
				let hasErrors = entry.deliveryTimeError !== null 
								&& entry.deliveryTimeError !== undefined
								&& entry.deliveryTimeError.length > 0;
				let selectButton = this.renderSelectButton(entry, disabled || hasErrors, hasSelection);
				let entryStatus = this.renderEntryStatus(entry.status, entry.statusComment);
				let entryCost = entry.cost ? numeral(entry.cost).format("0.00") : '';
				let rowClass = entry.isSelected ? 'bg-green disabled' : '';
				let deliveryTimeSpecifiedControl = this.renderIsDeliveryTimeSpecifiedControl(entry, disabled, hasSelection);
				let deliveryTimeControl = this.renderDeliveryTimeControl(entry, disabled, hasSelection);

				let tariffInfo = entry.tariff && entry.tariff.tariffDescription && entry.tariff.tariffDescription.length
					? this.renderTariffInfo(key, entry.tariff) : '';

				return (
					<tr key={key} className={rowClass}>
						<td>
							<span>{entry.carrierName}</span>
							{selectButton}
						</td>
						<td className="text-right">{entryCost}</td>
						<td>{entry.deliveryTimeComment}</td>
						<td>{entry.carrierServiceName} {tariffInfo}</td>
						<td>{entryStatus}</td>						
					</tr>
				);
			});
			return entries;
		} else {
			return null;
		}
	}

	renderTariffInfo(serviceKey, tariff) {
		let key = 'service-' + serviceKey;
		return (<a key={key} tabIndex="0" role="button" data-toggle="popover" data-trigger="hover"
			title={tariff.tariffName}
			data-content={tariff.tariffDescription}>
			<span className="glyphicon glyphicon-info-sign text-blue control-help-btn"></span>
		</a>);
	}

    renderErrors() {
		let errors = [];
        if (this.props.errors.selection) {
			errors.push(<p key="err-selection">{this.props.errors.selection}</p>);
        }
		if (this.props.errors.deliveryTime) {
			errors.push(<p key="err-deliveryTime">{this.props.errors.deliveryTime}</p>);
		}

		if (errors.length > 0) {
            return (
                <div className="callout callout-danger">
                    {errors}
                </div>
            );
        } else {
            return null;
        }
    }

    renderRefreshButton(disabled) {
        let hasEntriesToRefresh = false;
		if (this.props.parcel.carrierCostRequests) {
			this.props.parcel.carrierCostRequests.forEach((entry, ind, arr) => {
				if (entry.requestId) {
					hasEntriesToRefresh = true;
				}
			});
		}
        if (hasEntriesToRefresh) {
            return (
                <button className="btn btn-flat btn-default btn-sm btn-tool"
                    onClick={() => this.updateRequests()}
                    disabled={disabled}
                >
                    Обновить
                </button>
            );
        } else {
            return null;
        }
    }

	openHelpDialog() {
		if (this.infoModal) {
			let title = "Инструкция к форме «Расчет стоимости»";
			let message = "1. Нажмите кнопку «Запросить варианты доставки» для поиска вариантов доставки посылки. \n" 
						+ "2. Выберите один из предложенных вариантов, исходя из стоимости и сроков доставки. \n"
						+ "3. Если вам необходимо доставить груз позже указанной даты, поставьте галочку в соответствующей строке столбца «Доставка к другому времени». Внесите дату в поле «Доставка к другому времени» после его активации. \n"
						+ "4. Нажмите кнопку «Выбрать» рядом с названием транспортной компании для подтверждения выбора варианта доставки.";
			this.infoModal.open(title, message);
		}
	}

	renderHelpButton() {
		return (
            <button className="btn btn-flat btn-default btn-sm btn-tool" onClick={() => this.openHelpDialog()}>
                <span className="glyphicon glyphicon-question-sign control-help-btn text-blue"></span>
				Помощь
            </button>
		);
	}

    renderEmptyForm(disabled) {
        return (
			<div>
				{this.renderHelpButton()}
				<div className="cost-calc-button-wrapper">
					<button className="btn btn-flat btn-default cost-calc-button"
						onClick={() => this.sendRequests()}
						disabled={disabled}
					>
						Запросить варианты доставки
					</button>
				</div>
            </div>
        );
    }

	renderNewRequestButton(disabled)
	{
		return (
            <button className="btn btn-flat btn-default btn-sm btn-tool"
                onClick={() => this.sendRequests()}
                disabled={disabled}
            >
                Обновить варианты доставки
            </button>
		);
	}

    renderTableForm(disabled, canEdit) {
        let entries = this.renderEntries(disabled);
        let refreshButton = canEdit ? this.renderRefreshButton(disabled) : null;
		let newRequestButton = canEdit ? this.renderNewRequestButton(disabled) : null;
		let errorList = this.renderErrorsList();
        return (
            <div>
                <div className="box-header no-vert-padding">
					{this.renderHelpButton()}
                    {refreshButton}
                    {newRequestButton}
                </div>

                <div className="box-body table-responsive">
                    <table className="table table-bordered table-hover static-grid">
                        <thead>
                            <tr>
                                <th>Транспортная компания</th>
                                <th>Стоимость</th>
                                <th>Время доставки</th>
                                <th>Срочность</th>
                                <th>Статус запроса</th>                                
                            </tr>
                        </thead>
                        <tbody>
                            {entries}
                        </tbody>
                    </table>
                </div>

				{errorList}
            </div>
        );
    }

    render() {
		let isCoordinator = getRoles().indexOf('Coordinator') >= 0;
        let isOnlyBeforeSendEditable = this.props.isNew 
									|| this.props.parcel.statusCode === "Created" 
									|| (this.props.parcel.statusCode === "SentToMailRoom" && isCoordinator);
        let isBusy = this.props.isBusy || this.state.busyCount > 0;
        let errors = this.renderErrors();
        let hasEntries = this.props.parcel.carrierCostRequests && this.props.parcel.carrierCostRequests.length > 0;
        let data = null;
        if (hasEntries || !this.props.isNew || !isOnlyBeforeSendEditable) {
            data = this.renderTableForm(isBusy || !isOnlyBeforeSendEditable, isOnlyBeforeSendEditable);
        } else {
            data = this.renderEmptyForm(isBusy);
        }
        return (
            <div>
                {errors}
                {data}

				<ConfirmModal ref={modal => this.confirmModal = modal} />
                <InformationModal ref={modal => this.infoModal = modal} />
				<FillRecipientCompanyModal ref={modal => this.fillRecipientModal = modal} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./App/pages/parcels/form/tabs/costCalcTab.jsx